module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="breakpoints-assign-lightbox">\n    <h2>Assign Breakpoint Variants</h2>\n    <p class="intro">Assign your Breakpoint Variants to the intervals in which you want them to be shown.</p>\n\n    <ul class="breakpoints-flex-section list-unstyled">\n        ';
 _.each(assets, function(asset, index) { ;
__p += '\n            <li class="breakpoint-flex-item">\n                <div class="interval-indicator ' +
__e( asset[0] ) +
'">' +
__e( asset[0] ) +
'</div>\n                <select class="select-experience" ' +
__e( permissionToManage ? "" : "disabled" ) +
'>\n                    ';
 _.each(experiences, function(experience, index) { ;
__p += '\n                    <option value="' +
__e( experience.id ) +
'" ' +
__e( experience.id === asset[2].id ? "selected" : "" ) +
'>#' +
__e( index + 1 ) +
' ' +
__e( experience.get("name") ) +
'</option>\n                    ';
 }); ;
__p += '\n                </select>\n                <div class="breakpoint-value">' +
__e( asset[1].get('threshold') ) +
' px</div>\n            </li>\n        ';
 }); ;
__p += '\n    </ul>\n\n    <div class="actions">\n        ';
 if (breakpointModified) { ;
__p += '\n        <button class="update-btn btn btn-secondary pull-left" ' +
__e( permissionToManage ? "" : "disabled" ) +
'><span class="glyphicon glyphicon-exclamation-sign"></span> Update Breakpoints</button>\n        ';
 } ;
__p += '\n        <button class="ok-btn btn btn-primary pull-right ladda-button" ' +
__e( permissionToManage ? "" : "disabled" ) +
'>OK</button>\n        <button class="cancel-btn btn btn-secondary pull-right">Cancel</button>\n    </div>\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/editor/BreakpointAssignView.tpl
// module id = 2954
// module chunks = 0